/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputBase from '@material-ui/core/InputBase';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import flowRight from 'lodash/flowRight';
import { DownChevronSelectToggleItems } from './DownChevronSelectToggle';
import {
  depluralizeResourceName,
  capitalizeTheFirstLetterOfEachWord,
  translation,
} from '../../utils/Functions';
import SearchComponent from './SearchComponent';
import {
  getAdmin,
} from '../../selectors';
import {
  displayResourceStyles,
} from '../../css/style';
import { checkIsAuthorized, checkIsLocationAdmin } from '../../utils/AuthorizationChecks';
import { bulkActions } from '../../data/Constants';


const styles = displayResourceStyles();
class BasicToolBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBulkAction: '',
      isBulkActionSelectOpen: false,
    };
  }

  onClickAddResource = () => {
    const {
      actions, history, match, onClickAddResourceOverride,
    } = this.props;
    const { resource } = match.params;
    if (onClickAddResourceOverride && typeof onClickAddResourceOverride === 'function') {
      onClickAddResourceOverride();
      return;
    }

    actions.clearErrors();
    history.push(`/${resource}/create`);
  }

  renderAddNewResourceButton = resourceToDisplay => (
    <div style={styles.toolbarRightSideFlexEndContainer}>
      <Button
        variant="contained"
        onClick={this.onClickAddResource}
        style={styles.addNewResButton}
      >
        {`${translation('Add New')} ${resourceToDisplay}`}
      </Button>
    </div>
  )

  toggleBulkActionSelect = targetState => () => this.setState(
    { isBulkActionSelectOpen: targetState },
  );

  renderBulkActionSelect() {
    const { isBulkActionSelectOpen, selectedBulkAction } = this.state;
    const {
      classes,
      admin,
      resourceName,
      onBulkActionDropdownChange,
      match,
    } = this.props;
    const { resource } = match.params;
    const isLocationAdmin = checkIsLocationAdmin(admin);

    const authorizedActions = Object.entries(bulkActions).filter(
      ([config]) => !isLocationAdmin || config.isUsableByLocationAdmins,
    );

    return (
      <div style={styles.toolbarRightSideFlexEndContainer}>
        <FormControl>
          <Select
            open={isBulkActionSelectOpen}
            onOpen={this.toggleBulkActionSelect(true)}
            onClose={this.toggleBulkActionSelect(false)}
            value={selectedBulkAction}
            style={styles.bulkActionDropdownItems}
            classes={{
              root: classes.bulkActionInnerSelectItems,
              selectMenu: classes.bulkActionSelectMenuItems,
            }}
            input={<InputBase />}
            displayEmpty
            onChange={onBulkActionDropdownChange}
            IconComponent={
              DownChevronSelectToggleItems(this.toggleBulkActionSelect(!isBulkActionSelectOpen))
            }
          >
            <MenuItem value="">ACTIONS</MenuItem>
            {checkIsAuthorized(admin, resource, resourceName, 'edit')
              && (
                authorizedActions.map(
                  ([action, config]) => config.allowedPages.includes(resourceName) && (
                  <MenuItem value={action}>
                    {bulkActions[action].title}
                  </MenuItem>
                  ),
                )
              )}
          </Select>
        </FormControl>
      </div>
    );
  }

  render() {
    const {
      resourceName,
      handleSearch,
      handleClearSearch,
      admin,
      match,
      isBulkActions,
      children,
    } = this.props;

    const { resource } = match.params;
    const resourceTitle = resourceName === 'products' ? 'items' : resourceName;
    const resourceToDisplay = depluralizeResourceName(resourceTitle);
    const capitalizedResource = capitalizeTheFirstLetterOfEachWord(resourceTitle);

    return (
      <div style={styles.itemsToolbarContainer}>
        <div style={styles.toolbarLeftSideFlexStartContainer}>
          <SearchComponent
            placeholder={`Search ${capitalizedResource}`}
            onHandleSearch={handleSearch}
            onHandleClearSearch={handleClearSearch}
            resourceName={resourceTitle}
          />
          {children}
        </div>
        {isBulkActions && this.renderBulkActionSelect()}
        {checkIsAuthorized(admin, resource, resourceName, 'add') && this.renderAddNewResourceButton(resourceToDisplay)}
      </div>
    );
  }
}

BasicToolBar.propTypes = {
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  admin: PropTypes.objectOf(PropTypes.any),
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  resourceName: PropTypes.string.isRequired,
  onClickAddResourceOverride: PropTypes.func,
  handleSearch: PropTypes.func.isRequired,
  handleClearSearch: PropTypes.func.isRequired,
  isBulkActions: PropTypes.bool.isRequired,
  classes: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  onBulkActionDropdownChange: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.any),
};

BasicToolBar.defaultProps = {
  admin: {},
  onClickAddResourceOverride: null,
  onBulkActionDropdownChange: null,
  children: null,
};

const mapStateToProps = state => ({
  admin: getAdmin(state),
});

const pipeline = flowRight([
  withStyles(displayResourceStyles),
  withRouter,
  connect(mapStateToProps),
]);
export default pipeline(BasicToolBar);
